import React from 'react';

import { NavLinkProps, NavLink } from 'react-router-dom';
import './botao-card.css'


interface BotaoCardProps {
  navlink: NavLinkProps<any>
  icone: any
  iconeProps?: any
}

export const BotaoCard: React.FunctionComponent<BotaoCardProps> = (props) => {
  return (
    <NavLink {...props.navlink} className="botao-card">
      <div aria-hidden="true" className="botao-card-icone" ><props.icone {...props.iconeProps}/></div>
      <span className="botao-card-texto">{props.children}</span>
    </NavLink>
  )
}
